module.exports = __webpack_public_path__ + "static/media/icon-collapse.ce0e6edc.svg";